import { css } from 'styled-components';
import { theme } from '@frameio/vapor';

export const interactiveStyles = css`
  background-color: transparent;
  border-radius: ${theme.radii[8]};
  cursor: pointer;
  outline: none;
  transition:
    background-color ${theme.transitions.durations['100']}
      ${theme.transitions.eases.primary},
    box-shadow ${theme.transitions.durations['100']}
      ${theme.transitions.eases.primary};

  &:hover {
    background-color: ${theme.colors.background.interactive.hover};
  }

  &:focus-visible {
    box-shadow: inset 0 0 0 1.5px ${theme.colors.border.interactive.focused};
  }

  &:active {
    background-color: ${theme.colors.background.interactive.activatedSolid};
  }
`;

export const interactiveStylesWithActiveState = css`
  ${interactiveStyles}

  /* Active state background */
  &[data-active='true'] {
    background-color: ${theme.colors.background.interactive.activatedSolid};
  }

  /* Hover state when not active */
  &:hover:not([data-active='true']) {
    background-color: ${theme.colors.background.interactive.hover};
  }

  /* Focus visible state with active check */
  &:focus-visible:not([data-active='true']) {
    background-color: ${theme.colors.background.interactive.hover};
  }
`;
